import * as a1lib from "alt1";
import { Vector2 } from "../math";
import { ewent } from "../reactive";
import { ScreenRectangle } from "./ScreenRectangle";
import { util } from "../util/util";
var sampleImage = util.sampleImage;
var rgbSimilarity = util.rgbSimilarity;
export class Alt1ContextMenuDetection {
    constructor() {
        this.ewent = ewent();
        this.last_rect = null;
        a1lib.on("menudetected", e => {
            const event = new Alt1ContextMenuDetection.Event(e);
            this.last_rect = {
                origin: { x: e.rectangle.x, y: e.rectangle.y },
                size: { x: e.rectangle.width, y: e.rectangle.height },
            };
            this.ewent.trigger(this.last_rect);
        });
    }
    check(rect) {
        if (!this.last_rect)
            return null;
        const PIXEL_OFFSET = { x: 22, y: 6 };
        const expected_color = [28, 26, 18];
        const pos = Vector2.add(this.last_rect.origin, PIXEL_OFFSET);
        if (ScreenRectangle.contains(rect.screenRectangle(), pos)) {
            const sub = rect.getSubSection(ScreenRectangle.relativeTo(rect.screenRectangle(), { origin: pos, size: { x: 1, y: 1 } }));
            const pixel = sampleImage(sub.getData(), { x: 0, y: 0 });
            if (rgbSimilarity(expected_color, pixel) < 0.9) {
                this.last_rect = null;
                this.ewent.trigger(this.last_rect);
            }
        }
        return this.last_rect;
    }
    subscribe(handler) {
        return this.ewent.on(handler);
    }
}
(function (Alt1ContextMenuDetection) {
    class Event {
        constructor(raw) {
            this.raw = raw;
            this.rect = {
                origin: { x: raw.rectangle.x, y: raw.rectangle.y },
                size: { x: raw.rectangle.width, y: raw.rectangle.height },
            };
        }
    }
    Alt1ContextMenuDetection.Event = Event;
})(Alt1ContextMenuDetection || (Alt1ContextMenuDetection = {}));
